export enum StripeFeeType {
  APP = 'application_fee',
  STRIPE = 'stripe_fee',
}
